import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/react-bootstrap/esm/Row.js");
